"use strict";


/**
 * Module SERVICES
 */
angular.module("services")


/**
 * Service for the comptage module
 */
	.factory("WebSocketService",
		["$http", "$rootScope", "ENV", "Utils", "$q","$log",
			function ($http, $rootScope, ENV, Utils, $q, $log) {

				let websocket;
				let onMessageCallBack;
				let onErrorCallback;
				let doReconnect;
				let url;

				const enumWSMessages = {
					MODIFY_SUBSCRIBER_ENABLE: "MODIFY_SUBSCRIBER_ENABLE",
					MODIFY_SUBSCRIBER_DISABLE: "MODIFY_SUBSCRIBER_DISABLE",
					CONFIRM_SESSION_QUESTION: "CONFIRM_SESSION_QUESTION",
					CONFIRM_SESSION_ACK: "CONFIRM_SESSION_ACK",
					FORCE_GET_LOCK: "FORCE_GET_LOCK"
				};

				// PUBLIC API
				return {
					runWSLockSubscriberFile: runWSLockSubscriberFile,
					doSend                 : doSend,
					close                  : close,
					forceGetLock           : forceGetLock
				};

				/**
				 * Ouvre la connexion websocket
				 * @param wsUri
				 * @param afterReceiveMessage
				 * @param afterError
				 * @param reconnectAfterError
				 */
				function runWSLockSubscriberFile(wsUri, afterReceiveMessage, afterError, reconnectAfterError) {
					url                 = wsUri;
					websocket           = new WebSocket(wsUri);
					websocket.onopen    = function(evt) { onOpen(evt) };
					websocket.onclose; // not defined in order to manage unload page
					websocket.onmessage = function(evt) { onMessage(evt) };
					websocket.onerror   = function(evt) { onError(evt) };
					doReconnect         = reconnectAfterError;
					if(afterReceiveMessage) onMessageCallBack = afterReceiveMessage;
					if(afterError)          onErrorCallback   = afterError;
				}

				/**
				 * Ferme la connexion de la websocket
				 */
				function close()
				{
					websocket.close();
				}

				/**
				 * Quand la websocket est connectée
				 * @param evt
				 */
				function onOpen(evt) {
					if(console.log) console.log("CONNECTED");
				}

				/**
				 * Quand la websocket recoit un message du serveur
				 * @param evt
				 */
				function onMessage(evt) {
					const message = evt.data;
					let isLock = true;
					switch(message) {
						case enumWSMessages.MODIFY_SUBSCRIBER_ENABLE:
							isLock = false;
							break;
						case enumWSMessages.CONFIRM_SESSION_QUESTION:
							doSend(enumWSMessages.CONFIRM_SESSION_ACK);
							break;
						default: ;
					}
					if(typeof onMessageCallBack === "function")
						onMessageCallBack(isLock);
					else
					if(console.log) console.log("afterReceiveMessage - onMessageCallBack is not a function")
				}

				/**
				 * Traitement des erreurs
				 * @param evt
				 */
				function onError(evt) {
					const message = evt.data;
					$log.log("Erreur de connexion avec le serveur : " + message);

					if(typeof onErrorCallback === "function")
						onErrorCallback(message);
					else
						$log.log("afterError - onErrorCallback is not a function")


					if(doReconnect) runWSLockSubscriberFile(url);
				}

				/**
				 * Envoi de message au serveur
				 * @param message
				 */
				function doSend(message) {
					websocket.send(message);
				}

				/**
				 * Fonction pour prendre le lock
				 */
				function forceGetLock(){
					doSend(enumWSMessages.FORCE_GET_LOCK);
				}
			}

		])
;


